module.exports = __webpack_public_path__ + "static/media/nr.43db7339.svg";